import { Auth } from "aws-amplify";
import { DEFAULT_APP_VERSION, VARIANT_VX } from "../constants/login";

export async function loadUserVariant(): Promise<string> {
	try {
		if (process.env.REACT_APP_ENVIRONMENT === "OFFLINE") {
			return process.env.REACT_APP_VERSION || DEFAULT_APP_VERSION;
		}
		const user = await Auth.currentAuthenticatedUser();
		const raw = user?.attributes?.["custom:variant"] ?? DEFAULT_APP_VERSION;
		if (raw.toLowerCase() === VARIANT_VX) return VARIANT_VX;
		return raw;
	} catch {
		return DEFAULT_APP_VERSION;
	}
}

export function normalizeVariant(v: string) {
	return (v || DEFAULT_APP_VERSION).replace(/^\/+/, "");
}

export function isMultiVariant(v: string): boolean {
	return v.toLowerCase() === VARIANT_VX;
}
